var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('router-link',{attrs:{"to":{
      name: 'Profile',
      params: {id: Number(_vm.$store.getters.profile.id)}
    }}},[_c('ProfileIcon'),_vm._v(" "+_vm._s(_vm.$t("my_profile"))+" ")],1),_c('span',{staticClass:"disabled"},[_c('CollectionIcon'),_vm._v(" "+_vm._s(_vm.$t("collections"))+" ")],1),_c('router-link',{attrs:{"to":{
      name: 'Settings'
    }}},[_c('SettingsIcon'),_vm._v(" "+_vm._s(_vm.$t("settings.settings"))+" ")],1),_c('span',{staticClass:"disabled"},[_c('QuestionIcon'),_vm._v(" "+_vm._s(_vm.$t("questions_support"))+" ")],1),_c('hr'),_c('span',{on:{"click":_vm.logout}},[_c('LogoutIcon'),_vm._v(" "+_vm._s(_vm.$t("exit"))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }